<template>
  <router-link tag="div" :to="{name:'conference',params:{slug: conference.slug}}"
               class="slide_mainElement rounded overflow-hidden">
    <div class="slide_img">
      <img :src="img" alt="">
    </div>
    <div class="slide_content p-2">
      <p class="font-weight-bold text-break overflow-hidden description">{{ conference.title }}</p>
      <div class="d-flex mt-n2">
        <template v-if="diff>0">
          <img class="slide_icon" src="@img/time.svg">
          <small v-if="diff<24*60" class="ml-2 font-weight-light">{{ timer }}</small>
          <small v-else>
            {{ date.from(now) }}
          </small>
        </template>
        <span class="text-green" v-if="diff<0" style="font-size: 12px">
          En cours
        </span>
      </div>
    </div>
  </router-link>
</template>

<script>
import moment from 'moment'

export default {
  name: 'NextConference',
  props: {conference: {type: Object}},
  computed: {
    diff() {
      return this.date.diff(this.now, 'minute')
    },
    timer() {
      const hours = this.date.diff(this.now, 'hour')
      const minutes = this.date.diff(this.now, 'minute') % 60
      const seconds = this.date.diff(this.now, 'second') % 60
      return `${this.$format2Digits(hours)}:${this.$format2Digits(minutes)}:${this.$format2Digits(seconds)}`
    },
    img() {
      if (this.conference.type === 'group') return require('@img/group_discussion.jpg')
      else return require('@img/free_discussion.jpg')
    }
  },
  data() {
    return {
      now: moment(),
      date: moment(this.conference.date),
      interval: null
    }
  },
  mounted() {
    this.interval = setInterval(() => this.now = moment(), 1000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>

<style lang="scss">

.slide_mainElement {
  width: 80%;
  cursor: pointer;
  margin: 10px 0;
  background: white;
  box-shadow: 0 4px 2px rgba(#949494, .75) !important;
}

.slide_img {
  height: 150px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.slide_content {
  font-size: 13px;
  color: black;

  .description {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    max-height: 60px;
    height: 60px;
    /*min-height: 6.25em;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .slide_icon {
    width: 15px;
  }
}

</style>
